import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=2eefa2c6&scoped=true&"
var script = {}
import style0 from "./authLayout.vue?vue&type=style&index=0&id=2eefa2c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eefa2c6",
  null
  
)

export default component.exports